import { STATE_KEYS } from './state';

const GETTER_TYPES = {
  GET_MEDALLIA_INITIALIZATION_INFO: 'getMedalliaInitializationInfo',
  GET_DATA_STATE: 'getDataState',
  GET_CONFIGURATION_STEP: 'getConfigurationStep',
  GET_SKILLS: 'getSkills',
  GET_SURVEYS: 'getSurveys',
  GET_SELECTED_SURVEYS_SKILLS: 'getSelectedSurveysSkills',
  GET_CONFIG_SURVEY_INFO: 'getConfigSurveyInfo',
};

const getters = {
  [GETTER_TYPES.GET_MEDALLIA_INITIALIZATION_INFO](state) {
    return state[STATE_KEYS.MEDALLIA_INITIALIZATION_INFO];
  },
  [GETTER_TYPES.GET_DATA_STATE](state) {
    return state[STATE_KEYS.DATA_STATE];
  },
  [GETTER_TYPES.GET_CONFIGURATION_STEP](state) {
    return state[STATE_KEYS.CONFIGURATION_STEP];
  },
  [GETTER_TYPES.GET_SKILLS](state) {
    return state[STATE_KEYS.SKILLS];
  },
  [GETTER_TYPES.GET_SURVEYS](state) {
    return state[STATE_KEYS.SURVEYS];
  },
  [GETTER_TYPES.GET_SELECTED_SURVEYS_SKILLS](state) {
    return state[STATE_KEYS.SELECTED_SURVEYS_SKILLS];
  },
  [GETTER_TYPES.GET_CONFIG_SURVEY_INFO](state) {
    return state[STATE_KEYS.CONFIG_SURVEY_INFO];
  },
};

export {
  getters,
  GETTER_TYPES,
};
